// will contain some HTTP response helpers

export function extractErrorMessageAxios(axiosErrorResponse) {
  if (axiosErrorResponse.response && axiosErrorResponse.response.data && axiosErrorResponse.response.data.message) {
    return axiosErrorResponse.response.data.message;
  }
  return "Unknown error occured";
}

export function extractDataAxios(axiosSuccessResponse) {
  if (axiosSuccessResponse.data && axiosSuccessResponse.data.data) {
    return axiosSuccessResponse.data.data;
  }
  return null;
}

export function extractValidationErrorsAxios(axiosErrorResponse) {
  if (axiosErrorResponse.response && axiosErrorResponse.response.data && axiosErrorResponse.response.data.validationErrors) {
    let allErrors = [];
    Object.values(axiosErrorResponse.response.data.validationErrors).forEach(fieldErrors => allErrors = [...allErrors, ...fieldErrors]);
    return allErrors;
  }
  return null;
}